import React from "react";
import { Group, Line, Rect } from "react-konva";
import Metrics from "../Metrics";
import { getShapeMetric } from "../../../utils/canvas/getShapeMetric";
import { useSelector } from "react-redux";
import {
  getDimensions,
  getLineAlignment,
  getSelectedTexture,
  getTileShape,
} from "../../../lib/redux/slices/dimensions-slice";
import { getCanvasValues } from "../../../utils/canvas";
import useImage from "use-image";
import { getShapeCoordinate } from "../../../utils/canvas/getShapeCoordinate";
import { useDebounce } from "use-debounce";
import config from "../../../utils/config";

const TileShapeGroup = ({
  groupRef,
  canvasOffsetX,
  canvasOffsetY,
  canvasOffsetX1,
  canvasOffsetY1,
  scale
}) => {
  const [linePos, setLinePos] = React.useState([]);
  const currentShape = useSelector(getTileShape);
  const lineAlignment = useSelector(getLineAlignment);
  const { top, left, bottom, right } = useSelector(getDimensions);
  const texture = useSelector(getSelectedTexture);
  const { canvasTop, canvasLeft, canvasBottom, canvasRight } = getCanvasValues(
    { top, left, bottom, right },
    currentShape,
    lineAlignment
  );
  const [patternImage] = useImage(texture.image);

  const [debouncedTopValue] = useDebounce(canvasTop, config.debounceTime);
  const [debouncedLeftValue] = useDebounce(canvasLeft, config.debounceTime);
  const [debouncedRightValue] = useDebounce(canvasRight, config.debounceTime);
  const [debouncedBottomValue] = useDebounce(canvasBottom, config.debounceTime);

  const shapeCoordinate = React.useMemo(() => {
    return getShapeCoordinate(
      lineAlignment,
      currentShape,
      canvasTop,
      canvasLeft,
      canvasRight,
      canvasBottom,
      setLinePos
    );
  }, [
    canvasTop,
    canvasLeft,
    canvasRight,
    canvasBottom,
    currentShape,
    lineAlignment,
  ]);

  const lshapeMetrics = React.useMemo(() => {
    return getShapeMetric(
      lineAlignment,
      canvasOffsetX1,
      canvasOffsetY1,
      currentShape,
      canvasTop,
      canvasLeft,
      canvasRight,
      canvasBottom,
      canvasOffsetX,
      canvasOffsetY
    );
  }, [
    canvasOffsetX,
    canvasOffsetX1,
    canvasOffsetY,
    canvasOffsetY1,
    canvasTop,
    canvasLeft,
    canvasRight,
    canvasBottom,
    currentShape,
    lineAlignment,
  ]);

  return (
    <Group clearBeforeDraw>
      <Line
        ref={groupRef}
        points={shapeCoordinate || []}
        closed={true}
        shadowBlur={5}
        shadowOpacity={0.5}
        shadowOffsetX={5}
        shadowOffsetY={5}
        fillPatternRotation={90}
        fillPatternScaleX={1}
        fillPatternScaleY={1}
        fillPatternImage={patternImage}
        // fillPatternOffset={-1}
      />

      {/* Tile seperator Line */}

      {lineAlignment !== "standard" ? (
        <Line
          points={linePos}
          stroke="#74797b"
          strokeWidth={2}
          // shadowBlur={5}
          // shadowOpacity={0.5}
          // shadowOffsetX={5}
          // shadowOffsetY={5}
        />
      ) : null}

      {lshapeMetrics?.map((metric, i) => {
        const { x, y, width, height, text, orientation, rotation, degree,label } =
          metric;
 
        return (
          <Metrics
            key={i}
            x={x}
            y={y}
            width={width}
            height={height}
            text={text}
            orientation={orientation}
            rotation={rotation}
            canvasOffsetX={canvasOffsetX}
            canvasOffsetY={canvasOffsetY}
            degree={degree}
            scale={scale}
            label={''}
          />
        );
      })}
    </Group>
  );
};
export default TileShapeGroup;
